import * as yup from 'yup';

const initialValues = {
  performance: '',
  pcm: '',
};

const validationSchema = yup.object().shape({
  performance: yup
    .number()
    .typeError('Performance rating must be a number')
    .min(1, 'Performance rating must be at least 1')
    .max(5, 'Performance rating cannot exceed 5')
    .required('Performance rating is required'),
  pcm: yup
    .number()
    .typeError('PCM rating must be a number')
    .min(1, 'PCM rating must be at least 1')
    .max(5, 'PCM rating cannot exceed 5')
    .required('PCM rating is required'),
});

export { initialValues, validationSchema };
